import { getSupplyAddressesError } from '@essent/supply-address-v3';
import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';

import {
  clearSelectedSupplyAddressId,
  selectSupplyAddressId,
} from './select-supply-address.actions';

export interface SelectedSupplyAddressState {
  selectedSupplyAddressId?: string;
}

export const initialState: SelectedSupplyAddressState = {};

const _reducer = createReducer(
  initialState,
  on(selectSupplyAddressId, (state, action) => ({
    ...state,
    selectedSupplyAddressId: action.payload,
  })),
  on(clearSelectedSupplyAddressId, getSupplyAddressesError, () => initialState)
);

export function selectedSupplyAddressReducer(
  state: SelectedSupplyAddressState = initialState,
  action: Action
): SelectedSupplyAddressState {
  return _reducer(state, action);
}
